import { deviceKeyOf } from "../deviceKey";
import type { StepRunId } from "./types";

/**
 * A device override is keyed by the DURABLE device key — deliberately, so it
 * survives both a reassignment and a re-run — so only the geometry can say
 * which run a reshape belongs to.
 * Read off `byCircuit`, whose key IS the run: a path's own `routeId` is carried
 * data and re-parenting is what this has to survive.
 *
 * Two runs are as good as none: marking one of them names the wrong cable, and
 * marking every run a box removal crossed is most of the sheet.
 */
export const stepRunId: StepRunId = ({ summary, geometry }) => {
  if (summary.circuitId) return summary.circuitId;
  if (!geometry || !summary.destinationIds.length) return null;
  const wanted = new Set(summary.destinationIds);
  let found: string | null = null;
  for (const [circuitId, state] of Object.entries(geometry.byCircuit)) {
    // Either key: the step is a diff of two documents, so it speaks whatever
    // those documents were written in — and one of them may predate the durable
    // key. Missing here costs the undo hint its run name, quietly.
    if (
      !state.paths.some(
        (path) =>
          wanted.has(deviceKeyOf(path)) || wanted.has(path.destinationId),
      )
    ) {
      continue;
    }
    if (found) return null;
    found = circuitId;
  }
  return found;
};
